import { render, staticRenderFns } from "./Redactions.vue?vue&type=template&id=406d40e8&scoped=true&"
import script from "./Redactions.vue?vue&type=script&lang=js&"
export * from "./Redactions.vue?vue&type=script&lang=js&"
import style0 from "./Redactions.vue?vue&type=style&index=0&id=406d40e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d40e8",
  null
  
)

export default component.exports